const envValue = String(process.env.REACT_APP_ENABLE_SUBSCRIPTIONS || "").trim().toLowerCase();

// Hidden by default for now.
export const SUBSCRIPTIONS_ENABLED = envValue === "true";

// The CHOOSE BY... filter (date, level, place) under the upcoming games.
// Hidden while there are only a handful of games: filtering a short list adds
// a whole section without helping anyone find a game. The component is kept
// as it is; set REACT_APP_ENABLE_GAME_FILTER=true to bring it back.
export const GAME_FILTER_ENABLED =
  String(process.env.REACT_APP_ENABLE_GAME_FILTER || "").trim().toLowerCase() === "true";
